// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1JHqE","title":"Header_title__WPh3t","side":"Header_side__2IY3o"};